import { makeStyles } from '@material-ui/core'

export const myEmailRUConnectStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    height: 478,
    maxHeight: 478,
    width: 335,
    overflowY: 'hidden',
    [theme.breakpoints.down(400)]: {
      height: 'calc(100dvh - 196px)',
      width: 300,
    },
  },
  emailButton: {
    width: '100%',
  },
  tabScroll: {
    overflowY: 'auto',
    height: 443,
    maxHeight: 443,
    width: '100%',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 230px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabContain: {
    overflowY: 'hidden',
    height: '430px',
  },
  collapse: {
    height: '305px',
    flexShrink: '0',
  },
  eventIconDot: {
    fontSize: '12px',
    transform: 'scale(1) translate(-50%, 50%)',
    color: theme.palette.base.red,
  },
  modalTabs: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabBackground: {
    overflowY: 'hidden',
    width: '100%',
    height: 35,
  },
  tabText: {
    overflowY: 'hidden',
    display: 'flex',
    flex: '1',
    minHeight: 35,
    height: 35,
    minWidth: 30,
    width: 30,
    paddingLeft: 0,
    paddingRight: 0,
    color: theme.palette.base.red,
    backgroundColor: theme.palette.base.lightGray,
  },
  moveCalendar: {
    marginTop: '-100px',
    marginBottom: '-30px',
    zIndex: '0',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(400)]: {
      scale: '0.9',
      marginTop: '-111px',
      marginLeft: theme.spacing(-1),
    },
  },
  eventsHolder: {
    padding: '0px 10px',
  },
  eventScroll: {
    transition: 'all 1s ease',
    zIndex: '1',
  },
  dayView: {
    transition: 'all 1s ease',
    zIndex: '1',
    transform: 'translate(0, 10px)',
  },
  fullWidth: {
    width: '-webkit-fill-available',
  },
  badge: {
    color: theme.palette.base.red,
  },
  icon: {
    color: theme.palette.base.gray,
    fontSize: 40,
    '&:hover': {
      transform: 'scale(1.07)',
    },
  },
  headerText: {
    paddingLeft: '7px',
  },
  monthAndYear: {
    width: 'min-content',
    paddingBottom: '8px !important',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '6px !important',
    },
  },
  bellIcon: {
    color: theme.palette.base.red,
    fontSize: theme.typography.h2.fontSize,
    marginBottom: '-32px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-28px',
    },
  },
  dayOverlay: {
    color: theme.palette.base.white,
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down(769)]: {
      marginTop: theme.spacing(0.25),
    },
  },
  dayOverlayHolder: {
    width: 'min-content',
    paddingBottom: '18px !important',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '12px !important',
    },
  },
  eventsCard: {
    margin: '5px',
  },
  eventHeader: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  calendarDivider: {
    width: '-webkit-fill-available',
    zIndex: '1',
  },
  eventCard: {
    padding: '5px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  quickLinks: {
    overflowY: 'auto',
    height: 'calc(100dvh - 230px)',
  },
}))

export default myEmailRUConnectStyles
